import { render, staticRenderFns } from "./couponPackage.vue?vue&type=template&id=3a85d3bc&scoped=true&"
import script from "./couponPackage.vue?vue&type=script&lang=js&"
export * from "./couponPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85d3bc",
  null
  
)

export default component.exports